import moment from 'moment'

const formatFromIsoToFrDate = (date) =>
  moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY')

// converti une date au format YYYY-MM-DD
const formatDate = (date) => moment(date).format('YYYY-MM-DD')

const parseDate = (date) => {
  // parse depuis le format DD/MM/YYYY
  if (!date) return null

  const splitedDate = date.split('/')
  if (splitedDate.length !== 3) {
    return null
  }
  if (splitedDate[2].length !== 4) {
    // année non renseignée /!\ peut beuguer en l'an 10 000
    return null
  }
  const [day, month, year] = splitedDate

  return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
}

const getTemporality = (date) => {
  const today = moment().endOf('day')
  const parsedDate = parseJavaSimpleDateFormat(date)
  const dateDiff = today.diff(parsedDate, 'days')

  if (dateDiff === 0) {
    return { code: 'date.aujourdhui' }
  } else if (dateDiff === 1) {
    return { code: 'date.hier' }
  } else {
    return { code: 'date.ilYaNJours', value: [dateDiff] }
  }
}

const parseJavaSimpleDateFormat = (dateString) =>
  moment(dateString, 'DD/MM/YYYY HH:mm')

export { formatFromIsoToFrDate, parseDate, getTemporality, formatDate }
